import { render, staticRenderFns } from "./CoachStreamEnVivo.vue?vue&type=template&id=674239dd&scoped=true"
import script from "./CoachStreamEnVivo.vue?vue&type=script&lang=js"
export * from "./CoachStreamEnVivo.vue?vue&type=script&lang=js"
import style0 from "./CoachStreamEnVivo.vue?vue&type=style&index=0&id=674239dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674239dd",
  null
  
)

export default component.exports